import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { IPackageReducer } from "../interfaces/IRedux";
import {
  getClientPackages,
  getClientArticlesForPackage,
} from "../actions/packageActions";

import { SimpleMapper } from "../components/mappers";
import CPackageCard from "../cards/CPackageCard";

interface ComponentProps {
  getClientPackages: Function;
  getClientArticlesForPackage: Function;
  package?: IPackageReducer;
}

class ClientDashboardPackagesArchived extends React.Component<
  ComponentProps,
  {}
> {
  componentDidMount() {
    this.getResults();
  }

  getResults() {
    this.props.getClientPackages({
      archived: true,
    });
  }

  onShowPackageClick = (id) => {
    alert(id);
  };

  onEditPackageClick = (id) => {
    alert(id);
  };

  render() {
    const { loading, elements } = this.props.package;
    return (
      <>
        <div className="row">
          <div className="col-lg-12">
            <SimpleMapper
              loading={loading}
              elements={elements}
              component={CPackageCard}
              emptyMessage="No hay paquetes archivados"
              classNameContainer="container-grid"
              componentAditionalProps={{
                onEditPackageClick: this.onEditPackageClick,
                onShowPackageClick: this.onShowPackageClick,
              }}
            />
          </div>
        </div>
      </>
    );
  }
}

// @ts-ignore
ClientDashboardPackagesArchived.propTypes = {
  package: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  package: state.package,
});

export default connect(mapStateToProps, {
  getClientPackages,
  getClientArticlesForPackage,
})(ClientDashboardPackagesArchived);
